import React from 'react';

import {
  useAutomatedEmailReportSettingsWidgetQuery,
  useSaveAutomatedEmailReportRecipientMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useAutomatedEmailReportSettingsWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          email: tuple.data?.store?.automatedReportEmailRecipient ?? ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveAutomatedEmailReportRecipient(storeId: string) {
  const [fnMutate, tuple] = useSaveAutomatedEmailReportRecipientMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    (formState: types.IFormState) => {
      fnMutate({
        variables: {
          storeId,
          email: formState.email
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
